import { decodeToken } from "react-jwt";
import { useSelector } from "react-redux";

interface AuthState {
  accessToken: string;
}

const useIsDownloadAvailable = (): boolean => {
  const isAuthorized: string = useSelector<{ auth: AuthState }, string>(
    ({ auth }) => auth.accessToken
  );

  const myDecodedToken: any = decodeToken(isAuthorized);
  const userRole = myDecodedToken.role;

  // Check if the user's role allows for downloads
  return !(userRole === "Facility Manager" || userRole === "Facility Worker");
};

export default useIsDownloadAvailable;
